// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  padding: 0;
}

.btn.focus, .btn:focus {
  outline: 0;
  box-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/s1/s1-button-check/s1-button-check.component.scss"],"names":[],"mappings":"AAAA;EAAS,UAAA;AAET;;AADA;EACE,UAAA;EACA,2BAAA;AAIF","sourcesContent":["button { padding: 0; }\n.btn.focus, .btn:focus {\n  outline: 0;\n  box-shadow: none!important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
